export default "__VITE_ASSET__BuO0yPWA__"